/** Distingue visualmente y con texto la procedencia de cada dato (spec §2.2, §8.5). */
export type SourceKind = 'quadrado' | 'jcyl' | 'osm' | 'wikidata' | 'editorial';
const LABEL: Record<SourceKind, string> = {
  quadrado: 'Quadrado, 1884',
  jcyl: 'Junta de Castilla y León',
  osm: 'OpenStreetMap',
  wikidata: 'Wikidata',
  editorial: 'Nota editorial del proyecto',
};
export function SourceBadge({ kind, detail }: { kind: SourceKind; detail?: string }) {
  return (
    <span className={`src-badge src-badge--${kind}`}>
      <span className="src-badge__dot" aria-hidden="true" />
      <span className="visually-hidden">Fuente: </span>{LABEL[kind]}{detail ? <span className="src-badge__detail"> · {detail}</span> : null}
    </span>
  );
}
